export default function initShowMore() {
    let showMoreGroup = document.querySelectorAll('.show-more')

    if (!showMoreGroup) return

    showMoreGroup.forEach((group) => {
        let showMoreItem = group.querySelectorAll('.show-more__item')
        let moreBtn = group.querySelector('.more-btn')
		let moreCountDesc = group.getAttribute('data-desc')
		let moreCountMob = group.getAttribute('data-mob')

        for (let i = 0; i < showMoreItem.length; i++) {
            if (window.matchMedia("(max-width: 480px)").matches) {
                if (i > moreCountMob - 1) {
                    showMoreItem[i].classList.add('js__hidden')
                }
            } 
            else {
                if (i > moreCountDesc - 1) {
                    showMoreItem[i].classList.add('js__hidden')
                }
            } 
        }

        if (Array.from(showMoreItem).some(elem => elem.classList.contains('js__hidden'))) {
            moreBtn.classList.add('js__active')
            moreBtn.querySelector('.more-btn__count').innerHTML = ' ' + group.querySelectorAll('.show-more__item.js__hidden').length
            moreBtn.addEventListener('click', () => {
                showMoreItem.forEach((tab) => {
                    tab.classList.remove('js__hidden')
                    moreBtn.classList.remove('js__active')
                })
            })
        }

    })

}